import parentApi from "../../../../store/parentApi"
import { convertQueryObjToString } from "../../../../utils"

const FiltersApis = parentApi.injectEndpoints({
  endpoints: build => ({
    getFilterTags: build.query({
      query: params => `/appliedFilters?${convertQueryObjToString(params)}`,
    }),
  }),
})

export const { useGetFilterTagsQuery, useLazyGetFilterTagsQuery } = FiltersApis
